import React from "react";

type Props = {
	payload: {
		survey: {
			name: string;
			description?: string;
			questions: { text?: string; type?: string }[];
		};
	};
};

const TYPE_LABELS: Record<string, string> = {
	likert: "Likert",
	rating: "Rating",
	text: "Open text",
	multi_choice: "Choice",
	yes_no: "Yes / No",
};

export const SurveyPreview = ({ payload }: Props): React.ReactElement => {
	const visible = payload.survey.questions.slice(0, 6);
	const remainder = payload.survey.questions.length - visible.length;

	return (
		<div className="space-y-4">
			{payload.survey.description && (
				<p className="border-l-2 border-neutral-3 pl-3 text-paragraph-3 text-neutral-7 italic">
					{payload.survey.description}
				</p>
			)}

			<div className="flex items-baseline gap-3">
				<div className="text-heading-3 font-semi-bold text-neutral-9 tabular-nums">
					{payload.survey.questions.length}
				</div>
				<div className="text-paragraph-3 text-neutral-7">
					question{payload.survey.questions.length === 1 ? "" : "s"} in this survey
				</div>
			</div>

			<ul className="space-y-2">
				{visible.map((question, ii) => {
					const typeLabel = question.type ? (TYPE_LABELS[question.type] ?? question.type) : null;
					return (
						<li
							key={ii}
							className="flex items-start gap-3 rounded-sm bg-neutral-1 px-3 py-3 ring-1 ring-neutral-2"
						>
							<span className="mt-px w-6 shrink-0 text-caption font-semi-bold text-neutral-7 tabular-nums">
								{String(ii + 1).padStart(2, "0")}
							</span>
							<span className="flex-1 text-paragraph-3 text-neutral-9">
								{question.text ?? "(question)"}
							</span>
							{typeLabel && (
								<span className="inline-flex h-5 shrink-0 items-center rounded-full bg-neutral-2 px-2 text-caption text-neutral-9">
									{typeLabel}
								</span>
							)}
						</li>
					);
				})}
			</ul>

			{remainder > 0 && (
				<div className="pl-3 text-caption text-neutral-7">
					+ {remainder} more question{remainder === 1 ? "" : "s"} not shown
				</div>
			)}
		</div>
	);
};

export default SurveyPreview;
